import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { DownloadModal } from "@/components/DownloadModal";
import { AmbientGlow } from "@/components/Doodles";
import Landing from "@/pages/Landing";
import Blogs from "@/pages/Blogs";
import BlogPost from "@/pages/BlogPost";
import Premium from "@/pages/Premium";
import Legal from "@/pages/Legal";
import Careers from "@/pages/Careers";
import Help from "@/pages/Help";
import Sitemap from "@/pages/Sitemap";
import Admin from "@/pages/Admin";

function App() {
  const [dl, setDl] = useState(false);
  const open = () => setDl(true);
  return (
    <HelmetProvider>
      <BrowserRouter>
        <SmoothScroll>
          <div className="App tricolor-bg grain">
            <AmbientGlow />
            <Navbar />
            <main className="relative z-[2]">
              <Routes>
                <Route path="/" element={<Landing onProveIt={open} />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/blogs/:slug" element={<BlogPost />} />
                <Route path="/premium" element={<Premium />} />
                <Route path="/privacy-policy" element={<Legal tab="privacy" />} />
                <Route path="/terms" element={<Legal tab="terms" />} />
                <Route path="/child-safety" element={<Legal tab="child-safety" />} />
                <Route path="/help" element={<Help />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/sitemap" element={<Sitemap />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
            <DownloadModal open={dl} onOpenChange={setDl} />
            <Toaster position="bottom-center" richColors />
          </div>
        </SmoothScroll>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
